import { Palette } from '@core/config/constants';

/** Configuracion especifica del minijuego de aventura (atrapar estrellas). */
export const AdventureConfig = {
  key: 'AdventureScene',
  title: 'Aventura Estelar',
  description: 'Atrapa las estrellas y esquiva las nubes de tormenta.',
  icon: '🏃',
  color: Palette.secondary,

  /** Vidas con las que arranca el jugador. */
  startingLives: 3,
  /** Cada cuanto cae un objeto nuevo (ms). Baja con el tiempo para subir dificultad. */
  initialSpawnIntervalMs: 900,
  minSpawnIntervalMs: 380,
  /** Cuanto se acelera el ritmo de aparicion por cada objeto bueno atrapado (ms). */
  spawnSpeedupPerHitMs: 8,
  /** Velocidad de caida de los objetos (px por segundo). */
  fallSpeedMin: 220,
  fallSpeedMax: 420,
  /** Probabilidad (0-1) de que un objeto que cae sea una nube (peligro). */
  hazardChance: 0.28,
  /** Puntos por atrapar una estrella. */
  pointsPerStar: 15,
  /** Velocidad horizontal del jugador con teclado (px por segundo). */
  playerSpeed: 720,
  /** Radio aproximado de colision del jugador y de los objetos. */
  collisionRadius: 52,
  /** Monedas otorgadas al finalizar por cada 100 puntos. */
  coinsPer100Points: 1,
} as const;

/** Parametros de cada nivel de dificultad del minijuego de aventura. */
export interface AdventureDifficulty {
  readonly key: string;
  readonly label: string;
  readonly color: number;
  readonly startingLives: number;
  readonly initialSpawnIntervalMs: number;
  readonly minSpawnIntervalMs: number;
  readonly fallSpeedMin: number;
  readonly fallSpeedMax: number;
  readonly hazardChance: number;
}

export const ADVENTURE_DIFFICULTIES: readonly AdventureDifficulty[] = [
  { key: 'easy', label: '😊 Fácil', color: Palette.accent, startingLives: 5, initialSpawnIntervalMs: 1050, minSpawnIntervalMs: 480, fallSpeedMin: 180, fallSpeedMax: 320, hazardChance: 0.22 },
  { key: 'normal', label: '⭐ Normal', color: Palette.secondary, startingLives: 3, initialSpawnIntervalMs: 900, minSpawnIntervalMs: 380, fallSpeedMin: 220, fallSpeedMax: 420, hazardChance: 0.28 },
  { key: 'hard', label: '🔥 Difícil', color: Palette.primary, startingLives: 2, initialSpawnIntervalMs: 720, minSpawnIntervalMs: 300, fallSpeedMin: 300, fallSpeedMax: 540, hazardChance: 0.34 },
];
